import { Component, Vue } from 'vue-property-decorator';
import { request } from '@/tools/request.ts';

@Component<EntryWall>({
  components: {
    //
  },
})
export default class EntryWall extends Vue {
  protected baseUrl: string = process.env.VUE_APP_API_BASE_ENDPOINT || 'https://us-central1-api-solution.cloudfunctions.net/webApi/api/v1/';
  protected showPassword: boolean = false;
  protected entryCode: string = '';

  public mounted() {
    //
  }

  protected submitEntryCode() {
    const payload: any = {
      entryCode: this.entryCode,
    };

    let encrypt: boolean = true;

    request('post', `${this.baseUrl}entry`, payload, encrypt).then(
      (response: any) => {
        const currentTimestamp: any = Date.now();
        localStorage.setItem('allowEntry', currentTimestamp);
        this.$router.replace('/');
      },
      (error: any) => {
        console.log('request error', error);
        alert('Invalid code, please try again');
        this.entryCode = '';
      }
    );
  }

}
